import axios from "axios";
import { Modal } from "antd";
import { errorHandler, expiredTokenHandler } from "./helper";

export const maintenanceErrorCodes = [502, 410, 413];

// This function should be used for the backend error with these status code: 502, 410, 413 and 504 (504 even if after two times it still exist)
export const logErrorToTelegram =
  (
    user,
    email,
    error_code,
    request,
    response,
    route,
    showError = true,
    hasNavigated,
  ) =>
  async (dispatch) => {
    // if (
    //   showError &&
    //   request !== "inference" &&
    //   request !== "get_trade_suggestion/other_coins_to_analyse" &&
    //   !request?.includes("order_trade") &&
    //   !hasNavigated
    // ) {
    //   showMaintenanceError();
    // }

    let requestName = request;
    try {
      requestName = JSON.parse(request)?.requestType || request;
    } catch {
      requestName = request;
    }
    const description = `${error_code || "error"} ${requestName}`.trim();

    try {
      await axios.post(
        "https://nuih8j65u3.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        {
          description,
          user,
          email,
          error_code,
          request,
          response,
          route,
        },
      );
    } catch (err) {
      if (err?.response?.status === 450 && showError) {
        expiredTokenHandler("");
      }
    }
  };

export const showMaintenanceError = () => {
  return Modal.info({
    content: (
      <p style={{ marginBottom: 0, fontSize: "16px" }}>
        Dear user, we apologize for the inconvenience. <br />
        Our system is currently undergoing maintenance to provide you with a
        better service. Please check back later.
        <br />
        We appreciate your patience and understanding. Thank you!
      </p>
    ),
    centered: true,
  });
};

export const axiosErrorHandler = (
  error,
  retryCount,
  dispatch,
  callbackFunc,
  actionType,
  user,
  email,
  requestType,
  gap = 0,
  firstPath,
  maxRetries,
) => {
  const hasNavigated = firstPath !== window?.location?.href;

  let requestName = requestType;
  try {
    requestName = JSON.parse(requestType)?.requestType || requestType;
  } catch {
    requestName = requestType;
  }
  // console.log("user navigation", hasNavigated, firstPath, window.location.href);

  // gap keeps the older 5-try schedule. maxRetries overrides it, including 0
  // so a slow 504 is not fired again immediately.
  const retryNumber = Number.isInteger(maxRetries) ? maxRetries : gap ? 5 : 2;

  if (error?.response?.status === 504 || error?.response?.status === 454) {
    // console.log("504 error");
    if (retryCount < retryNumber) {
      // console.log("retry to fetch");
      if (gap && retryCount === 0) {
        setTimeout(() => {
          dispatch(callbackFunc());
        }, gap * 1000);
      } else {
        dispatch(callbackFunc());
      }
    } else {
      let action =
        actionType === "get_suggestion_error"
          ? "get_suggestion_pending"
          : actionType;
      dispatch({
        type: action,
        payload: error?.response?.data?.message || "Request failed",
      });
      dispatch(
        logErrorToTelegram(
          user,
          email,
          `${error?.response?.status}`,
          requestType,
          error?.response?.data,
          window?.location?.href,
          true,
          hasNavigated,
        ),
      );
    }
  } else if (maintenanceErrorCodes.includes(error?.response?.status)) {
    dispatch({
      type: actionType,
      payload: error?.response?.data?.message || error?.response?.data?.MESSAGE,
    });
    dispatch(
      logErrorToTelegram(
        user,
        email,
        error?.response?.status,
        requestType,
        error?.response?.data,
        window?.location?.href,
        true,
        hasNavigated,
      ),
    );
  } else {
    const responseData = error?.response?.data;
    dispatch({ type: actionType, payload: responseData || error?.message || "Request failed" });

    const STATUS_CODE = responseData?.STATUS_CODE;
    const MESSAGE = responseData?.MESSAGE;

    if (STATUS_CODE !== 504 && requestType?.includes("place-order")) return;

    errorHandler(
      STATUS_CODE,
      MESSAGE || error?.response?.data?.message,
      actionType,
      requestName,
    );
  }
};
